import styled from 'styled-components';
import { spacing, colors, body2 } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const Section = styled.section`
  display: grid;
  grid-template-columns: 1fr 2fr;
  padding: ${spacing.double} 0;
`;

export const LeftDiv = styled.div`
  padding-right: ${pxToRem(80)};
`;

export const RightDiv = styled.div`
  border: solid 1px ${colors.grey15};
  border-radius: ${spacing.quarter};
  padding: ${spacing.double};
`;

const Content = styled.div`
  align-items: center;
  display: grid;
`;

export const AuthPolicyContent = styled(Content)`
  grid-template-columns: 1fr ${pxToRem(110)};
  column-gap: ${spacing.base};
`;

export const SpacedFlexContainer = styled.div`
  display: inline-flex;
  gap: ${spacing.half};
`;

export const Description = styled.p`
  ${body2}
  ${colors.textSecondary}
`;
